export const ADMIN_SLUG = process.env.REACT_APP_ADMIN_SLUG || "console-8f2a7c";
export const ADMIN_BASE = `/${ADMIN_SLUG}`;

export const adminPath = (p = "") => (p ? `${ADMIN_BASE}${p.startsWith("/") ? p : `/${p}`}` : ADMIN_BASE);

// Rewrites legacy /admin... links (e.g. from backend notification payloads) to the secret base.
export const toAdminHref = (link) =>
  link && link.startsWith("/admin") ? `${ADMIN_BASE}${link.slice("/admin".length)}` : link;
